/**** Mecanique Mega Menu ****/
document.addEventListener('DOMContentLoaded', function () {
  const menuItems = document.querySelectorAll('.heading-mega-menu__item');
  const allCategories = ['cat-interieur', 'cat-exterieur', 'cat-travaux', 'cat-insectes'];

  menuItems.forEach((item, index) => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      
      menuItems.forEach(el => el.classList.remove('active'));

      this.classList.add('active');

      let categoryClass = '';

      switch (index + 1) {
        case 1:
          categoryClass = 'cat-interieur';
          break;
        case 2:
          categoryClass = 'cat-exterieur';
          break;
        case 3:
          categoryClass = 'cat-travaux';
          break;
        case 4:
          categoryClass = 'cat-insectes';
          break;
        default:
          return; // Pour les autres liens ("Nos marques" etc.), on ne fait rien
      }

      // Retirer .visible de toutes les catégories
      allCategories.forEach(cat => {
        document.querySelectorAll(`.${cat}`).forEach(el => el.classList.remove('visible'));
      });

      // Ajouter .visible aux éléments correspondant à la catégorie
      document.querySelectorAll(`.${categoryClass}`).forEach(el => el.classList.add('visible'));
    });
  });
});



/**** Mecanique Animation Burger Menu ****/
const details = document.querySelector('details[is="mega-menu-disclosure"]');
const button = document.querySelector('.box-burger-menu .box-burger-menu__bloc');

if (details && button) {
  updateButtonState();

  // Sur changement d'état du <details>
  details.addEventListener('toggle', updateButtonState);

  function updateButtonState() {
    const isOpen = details.hasAttribute('open');

    button.classList.toggle('active', isOpen);
    button.classList.toggle('not-active', !isOpen);
  }
}



/**** Mecanique Animation Typing Header *****/
document.addEventListener("DOMContentLoaded", function () {
  const words = ["Savon noir", "Carrelage", "Anti moisissures", "Vitres", "Fiel de boeuf", "Saturateur"];
  const typingSpeed = 100;
  const erasingSpeed = 80;
  const delayBetweenWords = 0;
  const typedText = document.getElementById("typed-text-search");

  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;

  function type() {
    const currentWord = words[wordIndex];

    if (!isDeleting && charIndex <= currentWord.length) {
      typedText.textContent = currentWord.substring(0, charIndex++);
      setTimeout(type, typingSpeed);
    } else if (isDeleting && charIndex >= 0) {
      typedText.textContent = currentWord.substring(0, charIndex--);
      setTimeout(type, erasingSpeed);
    } else {
      isDeleting = !isDeleting;
      if (!isDeleting) {
        wordIndex = (wordIndex + 1) % words.length;
      }
      setTimeout(type, delayBetweenWords);
    }
  }

  type();
});




/***** Mecanique Accordeon Transparence Ingrédients *****/
document.addEventListener('DOMContentLoaded', function () {
  // Pour chaque section indépendante !
  var sections = document.querySelectorAll('.section-starwax-transparence-ingredient');
  sections.forEach(function(section) {
    // Accordéon principal
    var accordeon = section.querySelector('.accordeon-matieres-actives');
    var cta = section.querySelector('.cta-open-ma');
    if (accordeon && cta) {
      accordeon.style.overflow = 'hidden';
      accordeon.style.maxHeight = '0px';
      accordeon.classList.remove('open');
      cta.classList.remove('active');

      cta.addEventListener('click', function () {
        if (!accordeon.classList.contains('open')) {
          accordeon.classList.add('open');
          accordeon.style.maxHeight = accordeon.scrollHeight + 'px';
          cta.classList.add('active');
        } else {
          accordeon.style.maxHeight = accordeon.scrollHeight + 'px';
          void accordeon.offsetWidth;
          accordeon.style.maxHeight = '0px';
          accordeon.classList.remove('open');
          cta.classList.remove('active');
        }
      });
      accordeon.addEventListener('transitionend', function () {
        if (accordeon.classList.contains('open')) {
          accordeon.style.maxHeight = accordeon.scrollHeight + 'px';
        }
      });
    }

    // Sous-onglets propres à la section
    var onglets = section.querySelectorAll('.onglet-close');
    onglets.forEach(function (content) {
      content.classList.remove('open');
      content.style.maxHeight = '0px';
      content.style.paddingTop = '0';
      content.style.paddingBottom = '0';
    });

    var titres = section.querySelectorAll('.ma-onglet-titre');
    titres.forEach(function (titre) {
      titre.addEventListener('click', function () {
        var content = titre.parentElement.querySelector('.onglet-close');
        if (!content) return;

        var maOnglet = titre.closest('.ma-onglet');
        if (content.classList.contains('open')) {
          content.style.maxHeight = (content.scrollHeight + 20) + 'px';
          void content.offsetWidth;
          content.style.maxHeight = '0px';
          content.classList.remove('open');
          if (maOnglet) maOnglet.classList.remove('visible');
        } else {
          onglets.forEach(function (c) {
            c.style.maxHeight = '0px';
            c.classList.remove('open');
            var parentOnglet = c.closest('.ma-onglet');
            if (parentOnglet) parentOnglet.classList.remove('visible');
          });
          content.classList.add('open');
          content.style.maxHeight = (content.scrollHeight + 20) + 'px';
          if (maOnglet) maOnglet.classList.add('visible');
        }
      });
    });
  });
});




/***** Ajout de classe pour la tab "Rang" du programme de fidélité *****/
setTimeout(function () {
  const tiers = ["tier-bronze", "tier-argent", "tier-or", "tier-vip"];
  const liItems = document.querySelectorAll(".loyalty-tier-ui-tabs ul li");

  liItems.forEach((li, index) => {
    if (tiers[index]) {
      li.classList.add(tiers[index]);
    }
  });

  const tierContents = [
    "tier-bronze-content",
    "tier-argent-content",
    "tier-or-content",
    "tier-vip-content"
  ];
  const contentItems = document.querySelectorAll(".loyalty-tier-ui .loyalty-tier-ui-tab-content");

  contentItems.forEach((content, index) => {
    if (tierContents[index]) {
      content.classList.add(tierContents[index]);
    }
  });
}, 5000); // délai de 5000 ms (5 seconde)






/****** Script pour Les points de fidélités dans le panier   ******/
/*** OFF ACTUELLEMENT
  document.addEventListener("DOMContentLoaded", function () {
    const ratio = 30; // 30 points = 1 €

    function injectPointsMessage() {
      const container = document.querySelector('.aaa-loyalty-cartredeem-widget');

      // Vérifie que le widget de l'app est là
      const existingInput = document.querySelector('.enter_points');
      if (!container || !existingInput) return;

      // Empêche d'injecter plusieurs fois
      if (document.querySelector('.points-value-message')) return;

      // Crée l'élément du message
      const messageDiv = document.createElement('div');
      messageDiv.className = 'points-value-message';
      messageDiv.style.cssText = 'font-size: 14px; color: #333; margin-top: 10px;';
      container.appendChild(messageDiv);

      function updateMessage() {
        const points = parseInt(existingInput.value, 10);
        if (!isNaN(points) && points > 0) {
          const euros = (points / ratio).toFixed(2);
          messageDiv.textContent = `Vous obtiendrez une réduction de ${euros} € pour ${points} points utilisés.`;
        } else {
          messageDiv.textContent = '';
        }
      }

      existingInput.addEventListener('input', updateMessage);
      updateMessage(); // appel initial
    }

    // Observe les changements du cart drawer
    const observer = new MutationObserver(() => {
      injectPointsMessage();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
*****/



/***** POPUP POUR les utilisateurs venant de Mamawax *******/

  document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const source = urlParams.get("utm_source");

  if (source && source.toLowerCase() === "mamawax") {
    // Crée le fond assombri
    const overlay = document.createElement("div");
    overlay.id = "mamawax-popup-overlay";
    overlay.style = `
      position: fixed;
      top: 0; left: 0;
      width: 100%; height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
    `;

    // Crée la popup
    const popup = document.createElement("div");
    popup.id = "mamawax-popup";
    popup.style = `
      background: white;
      padding: 30px;
      max-width: 400px;
      text-align: center;
      border-radius: 10px;
      font-family: inherit;
      border-bottom-right-radius: 50px;
    `;

    // Contenu HTML de la popup
    popup.innerHTML = `
      <img src="https://cdn.shopify.com/s/files/1/0938/3513/3257/files/logo_mmx_starwax-co.svg?v=1751315881" alt="Starwax devient Mamawax" style="max-width: 100%; width: 250px; margin: auto;">
      <h2 class="h4" style="margin-bottom: 15px; margin-top: 20px; color:#1B2C4C;">Nouveau site, même expertise, plus de choix</h2>
      <p style="margin-bottom: 10px; color: #1B2C4C;">
        Pour vous souhaiter la bienvenue,<br>
        profitez de <strong>-10% sur votre 1<sup>ère</sup> commande</strong>.
      </p>
      <p style="font-size: 18px; font-weight: bold; margin-bottom: 15px; color: #1B2C4C;">
        Code : <span style="background:#EDF2F9; padding: 4px 8px; border-radius: 10px;">BIENVENUE10</span>
      </p>
      <button id="mamawax-popup-close" style="padding: 10px 20px; background: #758BFD; color: white; border: none; cursor: pointer; border-radius: 50px;">
        Merci, je continue !
      </button>
    `;

    // Ajoute la popup à l'overlay
    overlay.appendChild(popup);
    document.body.appendChild(overlay);

    // Fermer la popup au clic sur le bouton
    document.getElementById("mamawax-popup-close").addEventListener("click", function () {
      document.getElementById("mamawax-popup-overlay").remove();
    });

    // Fermer la popup au clic en dehors de la popup (sur l'overlay)
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        overlay.remove();
      }
    });
  }
});


/**** Mecanique Cross-Selling : proposition d'un produit complémentaire après ajout au panier ****/
(function () {
  var modal = document.getElementById('cross-sell-modal');
  if (!modal) return;

  var EASING = 'cubic-bezier(0.86, 0, 0.07, 1)'; // même easing que les animations natives du thème
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isClosing = false;

  function isMobileViewport() {
    return window.matchMedia('(max-width: 700px)').matches;
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      drawer.show();
    }
  }

  function openModal() {
    modal.hidden = false;
    isClosing = false;

    var dialog = modal.querySelector('.cross-sell-modal__dialog');
    var overlay = modal.querySelector('.cross-sell-modal__overlay');
    if (prefersReducedMotion || !dialog.animate) return;

    // Annule les animations de fermeture précédentes (fill: forwards figeait l'état final)
    dialog.getAnimations().forEach(function (anim) { anim.cancel(); });
    overlay.getAnimations().forEach(function (anim) { anim.cancel(); });

    overlay.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease', fill: 'forwards' });
    if (isMobileViewport()) {
      dialog.animate(
        [{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }],
        { duration: 350, easing: EASING, fill: 'forwards' }
      );
    } else {
      dialog.animate(
        [{ opacity: 0, transform: 'translateY(16px) scale(0.97)' }, { opacity: 1, transform: 'translateY(0) scale(1)' }],
        { duration: 250, easing: EASING, fill: 'forwards' }
      );
    }
  }

  function closeModal() {
    if (modal.hidden || isClosing) return;

    var dialog = modal.querySelector('.cross-sell-modal__dialog');
    var overlay = modal.querySelector('.cross-sell-modal__overlay');
    if (prefersReducedMotion || !dialog.animate) {
      modal.hidden = true;
      return;
    }

    isClosing = true;
    dialog.getAnimations().forEach(function (anim) { anim.cancel(); });
    overlay.getAnimations().forEach(function (anim) { anim.cancel(); });
    overlay.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: 'ease', fill: 'forwards' });
    var closeAnim = dialog.animate(
      isMobileViewport()
        ? [{ transform: 'translateY(0)' }, { transform: 'translateY(100%)' }]
        : [{ opacity: 1, transform: 'translateY(0) scale(1)' }, { opacity: 0, transform: 'translateY(16px) scale(0.97)' }],
      { duration: 200, easing: 'ease-in', fill: 'forwards' }
    );

    closeAnim.onfinish = function () {
      modal.hidden = true;
      isClosing = false;
    };
  }

  // Phase de capture : s'exécute avant le listener "variant:add" du cart drawer,
  // ce qui permet de bloquer son ouverture via blockCartDrawerOpening
  document.addEventListener('variant:add', function (event) {
    if (!modal.hidden) return; // modal déjà ouvert (ex : ajout du complémentaire)

    var triggerId = modal.getAttribute('data-trigger-product-id');
    var addedItems = (event.detail && event.detail.items) || [];
    var isTrigger = addedItems.some(function (item) {
      return String(item.product_id) === triggerId;
    });
    if (!isTrigger) return;

    // Masque les complémentaires déjà présents dans le panier
    var cartItems = (event.detail && event.detail.cart && event.detail.cart.items) || [];
    var cards = Array.prototype.slice.call(modal.querySelectorAll('[data-comp-product-id]'));
    var hasPending = false;

    cards.forEach(function (card) {
      var compId = card.getAttribute('data-comp-product-id');
      var inCart = cartItems.some(function (cartItem) {
        return String(cartItem.product_id) === compId;
      });
      card.hidden = inCart;
      if (!inCart) hasPending = true;
    });

    if (!hasPending) return; // tous les complémentaires déjà dans le panier

    event.detail.blockCartDrawerOpening = true;
    openModal();
  }, true);

  // Fermeture du modal → le cart drawer s'ouvre enfin
  modal.addEventListener('click', function (event) {
    if (event.target.closest('[data-cross-sell-dismiss]')) {
      closeModal();
      openCartDrawer();
    }
  });

  // L'ajout d'un complémentaire dispatch son propre "variant:add" qui remonte dans le modal :
  // on ferme le modal et le drawer s'ouvre via le comportement natif
  modal.addEventListener('variant:add', function () {
    closeModal();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
      openCartDrawer();
    }
  });
})();


/**** Mecanique Sequencage des popups : CookieYes (CMP) d'abord, puis Newsletter / SMS ****/
/* La bannière de consentement est prioritaire (obligation légale). Les popups du thème
   attendent que l'utilisateur ait tranché les cookies avant de s'afficher, et ne
   s'affichent jamais l'une par-dessus l'autre. */
(function () {
  var MANAGED_POPUPS = ['newsletter-popup', 'sms-popup'];
  var popupQueue = [];
  var queueTimer = null;

  function ckyCookieValue() {
    var match = document.cookie.match(/cookieyes-consent=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function elVisible(el) {
    if (!el) return false;
    if (typeof el.checkVisibility === 'function') {
      return el.checkVisibility({ checkVisibilityCSS: true });
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function cmpBannerVisible() {
    // CookieYes cache/supprime sa bannière une fois la décision prise
    var selectors = ['#cky-consent', '.cky-consent-container', '#cky-banner', '[id^="cky-banner"]', '[class*="cky-consent"]'];
    return selectors.some(function (selector) {
      return Array.prototype.some.call(document.querySelectorAll(selector), elVisible);
    });
  }

  function cmpInstalled() {
    return typeof window.getCkyConsent === 'function' || cmpBannerVisible() || ckyCookieValue() !== '';
  }

  function consentDecided() {
    // CookieYes écrit le cookie DÈS le chargement avec action:no :
    // le consentement n'est tranché que lorsque action:yes (accepter/refuser/personnaliser)
    if (/action\s*:\s*yes/i.test(ckyCookieValue())) return true;
    // CMP totalement absent (ni cookie, ni API, ni bannière) → rien à attendre
    return !cmpInstalled();
  }

  function anotherPopupOpen() {
    return !!document.querySelector(MANAGED_POPUPS.map(function (tag) {
      return tag + '[open]';
    }).join(', '));
  }

  function processQueue() {
    if (!popupQueue.length) {
      clearInterval(queueTimer);
      queueTimer = null;
      return;
    }

    var item = popupQueue[0];
    var waitedMs = Date.now() - item.queuedAt;
    // CookieYes absent → on ne bloque pas ; dernier recours : 90s sans décision → on affiche quand même
    var cmpAbsent = !cmpInstalled() && waitedMs > 8000;
    var giveUp = waitedMs > 90000;
    var decided = consentDecided();
    var blockedByPopup = anotherPopupOpen();

    if (!decided && !cmpAbsent && !giveUp) return;
    if (blockedByPopup) return;

    popupQueue.shift();

    // Petite grâce : laisse la bannière terminer son animation de fermeture
    setTimeout(function () {
      item.origShow.apply(item.el, item.args);
    }, 600);
  }

  function queuePopup(el, origShow, args) {
    popupQueue.push({ el: el, origShow: origShow, args: args, queuedAt: Date.now() });
    if (!queueTimer) {
      queueTimer = setInterval(processQueue, 500);
    }
  }

  function patchPopup(tag) {
    var Klass = window.customElements.get(tag);
    if (!Klass || Klass.__popupSequencerPatched) return;
    Klass.__popupSequencerPatched = true;

    var origShow = Klass.prototype.show;
    Klass.prototype.show = function () {
      var args = arguments;
      if (consentDecided() && !anotherPopupOpen()) {
        return origShow.apply(this, args);
      }
      queuePopup(this, origShow, args);
    };
  }

  MANAGED_POPUPS.forEach(function (tag) {
    // whenDefined garantit le patch avant le timer d'apparition, quel que soit le timing de theme.js
    window.customElements.whenDefined(tag).then(function () {
      patchPopup(tag);
    }).catch(function () {});
  });
})();